import { Box, Typography } from '@material-ui/core';
import type { TestRun } from '../../interfaces/ui';

interface LastRunStatsProps {
  latestRun?: TestRun;
  isCurrentRunInProgress: boolean;
  isMobile: boolean;
}

const LastRunStats = ({
  latestRun,
  isCurrentRunInProgress,
  isMobile,
}: LastRunStatsProps) => {
  const stats = [
    {
      label: 'Last Run',
      value: latestRun?.startedAt?.toLocaleDateString?.() || '—',
    },
    {
      label: 'Test Cases',
      value:
        latestRun?.testCases !== null && latestRun?.testCases !== undefined
          ? latestRun.testCases
          : '—',
    },
    {
      label: 'Pass Rate',
      value:
        latestRun?.passRate !== null && latestRun?.passRate !== undefined
          ? `${latestRun.passRate}%`
          : '—',
    },
    {
      label: 'Failed',
      value:
        latestRun?.failed !== null && latestRun?.failed !== undefined
          ? latestRun.failed
          : '—',
    },
    {
      label: 'Skipped',
      value:
        latestRun?.skipped !== null && latestRun?.skipped !== undefined
          ? latestRun.skipped
          : '—',
    },
  ];

  return (
    <Box className="pc-zone-stats">
      <Box
        className={`pc-kpi-metrics${isMobile ? ' pc-kpi-metrics-mobile' : ''}`}
      >
        {stats.map(({ label, value }) => (
          <Box
            key={label}
            className={`pc-kpi-chip${
              !latestRun ? ' pc-kpi-chip-placeholder' : ''
            }`}
          >
            <Typography
              component="span"
              variant="caption"
              className="pc-kpi-label"
            >
              {label}
            </Typography>
            {isCurrentRunInProgress ? (
              <Box className="pc-kpi-dots" aria-label="Loading">
                <span className="pc-kpi-dot" />
                <span className="pc-kpi-dot" />
                <span className="pc-kpi-dot" />
              </Box>
            ) : (
              <Typography
                component="span"
                className={`pc-kpi-value${
                  !latestRun ? ' pc-kpi-value-placeholder' : ''
                }`}
              >
                {String(value)}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default LastRunStats;
